<template>
  <v-navigation-drawer app right permanent style="height: calc(100vh - 30px)">
    <div v-if="selectedParty" class="pa-4 h-full d-flex flex-column">
      <h5>Carrinho</h5>

      <template v-if="cart._kit">
        <p class="text-overline mb-0 lh-1">Pacote</p>
        <h5>{{ cart._kit.kit.name }}</h5>
        <b class="mt-4 mb-1">
          Ite{{ cart._kit.kit.Items !== 1 ? "m" : "ms" }}:
        </b>
        <v-alert
          v-for="(item, index) in cart._kit.kit.Items"
          :key="index"
          text
          dense
          outlined
          class="pa-2 px-3"
          color="info"
        >
          <div class="d-flex gap-3 align-center">
            <h5 class="mb-0">{{ item.quantity }}x</h5>
            <div>
              <h6 class="mb-0">{{ item.TicketBlock.TicketGroup.name }}</h6>
              <span> {{ item.TicketBlock.name }} </span>
            </div>
          </div>
        </v-alert>
      </template>
      <template v-else>
        <h5>
          Ingresso{{ processedCart?.totalValue?.quantity !== 1 ? "s" : "" }}
        </h5>
        <v-alert
          v-for="(item, index) in processedCart.list"
          :key="index"
          text
          dense
          outlined
          class="pa-2 px-3"
          color="info"
        >
          <div class="d-flex gap-3 align-center">
            <h5 class="mb-0">{{ item.quantity }}x</h5>
            <div>
              <h6 class="mb-0">{{ item.ticketGroup.name }}</h6>
              <span> {{ item.ticketBlock.name }} </span>
            </div>
          </div>
        </v-alert>
      </template>

      <v-spacer></v-spacer>

      <span class="text-overline lh-1">
        {{ processedCart?.totalValue?.quantity }} ingresso{{
          processedCart?.totalValue?.quantity !== 1 ? "s" : ""
        }}
      </span>
      <h5 class="mb-0 lh-0">
        Total:
        {{
          (processedCart?.totalValue?.total - processedCart?.totalValue?.fee)
            | currency()
        }}
      </h5>
      <p class="lh-1 secondary--text">
        +Taxas a partir: {{ processedCart?.totalValue?.fee | currency() }}
      </p>
      <v-btn
        v-if="step.id === 'tickets'"
        block
        large
        depressed
        color="primary"
        class="flex-grow-0"
        :disabled="processedCart?.totalValue?.quantity === 0"
        @click="$emit('next')"
      >
        Finalizar Venda
      </v-btn>
      <v-btn
        v-if="step.id === 'client'"
        block
        depressed
        text
        class="flex-grow-0"
        @click="changeCart"
      >
        Alterar Carrinho
      </v-btn>
      <v-btn
        v-if="step.id === 'payment'"
        block
        depressed
        text
        color="error"
        class="flex-grow-0"
        @click="cancelPayment"
      >
        Cancelar Venda
      </v-btn>
    </div>
    <div
      v-else
      class="pa-4 h-full d-flex flex-column justify-center align-center"
    >
      <v-icon large class="mb-4">mdi-cart-off</v-icon>
      <h5 class="secondary--text text-center">
        Selecione um evento para continuar
      </h5>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { process } from "@/utils/shop/cart";
import VIRTUAL_POS from "@/services/staff/virtualPos";

export default {
  name: "CartSideBar",
  props: {
    token: {
      type: Object,
      required: true,
    },
    cart: {
      type: Object,
      required: true,
    },
    step: {
      type: Object,
    },
    selectedParty: {
      type: Object,
    },
    payment: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    async cancelPayment() {
      try {
        await VIRTUAL_POS.cancelPayment(this.token, this.payment.id);
      } catch (error) {
        console.error(error);
      } finally {
        this.$emit("update:payment", null);
        this.$emit("restart");
      }
    },
    changeCart() {
      const newCart = { ...this.cart };
      delete newCart._kit;
      this.$emit("update:cart", newCart);
      this.$emit("prev");
    },
  },
  computed: {
    processedCart() {
      if (this.cart._kit) {
        const { kit } = this.cart._kit;
        return {
          totalValue: {
            quantity: kit.Items.reduce(
              (sum, item) => sum + (item.quantity || 0),
              0
            ),
            total: kit.price + (kit.fee || 0),
            fee: kit.fee,
          },
        };
      }
      return process(this.cart);
    },
  },
};
</script>
